import { createFileRoute } from '@tanstack/react-router'
import { requireModule, requirePermission } from '../../app/guards'
import { ProjectBudgetVsActualPage } from '../../features/reports/project-budget-page'
import { budgetVsActualSearchSchema } from '../../features/reports/project-reports-search'

export const Route = createFileRoute('/_app/project-budget-vs-actual')({
  staticData: { crumb: 'projectBudgetVsActual' },
  validateSearch: budgetVsActualSearchSchema,
  beforeLoad: ({ context }) => {
    requireModule(context.session, 'projects')
    requirePermission(context.session, 'projects.reports')
  },
  component: ProjectBudgetVsActualPage,
})
